export default __webpack_public_path__ + "static/media/local_ha.f0a6903f.svg";